import React, { useEffect, useRef, useState } from 'react';
import { MdEdit } from 'react-icons/md';
import { HeadingWithCreateBtn, Search, Table } from 'src/components';
import CrudIcon from 'src/components/crud-icon';
import DashboardLayout from 'src/containers/dashboard-layout';
import useFetch from 'src/hooks/useFetch';
import AddTables from './crud/AddTables';
import { shallowEqual, useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import { fetchTable } from 'src/redux/action/table.action';
import Button from 'src/components/button';
import QrModal from 'src/components/QrModal';
import { AiOutlinePlus } from 'react-icons/ai';
import Loader from 'src/components/loader';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

interface IProps {}

const Actions = ({ row, handleEdit }: any) => {
  const [showAction, setShowAction] = useState<any>(false);
  const actionsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        actionsRef.current &&
        !actionsRef.current.contains(event.target as Node)
      ) {
        setShowAction(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative">
      <button
        className="p-2"
        onClick={() => {
          setShowAction(!showAction);
        }}
      >
        ...
      </button>
      {showAction && (
        <div
          ref={actionsRef}
          className="z-10 absolute  left-1/2 -bottom-12 border-[1px] border-border-color bg-pure-white shadow-lg p-2 -translate-x-1/2"
        >
          <CrudIcon
            data={row}
            url="/floors/tables/remove"
            fetchData={fetchTable() as any}
          >
            <div
              className="w-7 h-7 rounded-xl bg-light-grey bg-opacity-50 flex items-center justify-center"
              onClick={handleEdit}
            >
              <MdEdit color="#4062FF" />
            </div>
          </CrudIcon>
        </div>
      )}
    </div>
  );
};

const Tables: React.FC<IProps> = ({}) => {
  const [showModal, setShowModal] = React.useState(true);
  const [query, setQuery] = React.useState('');
  const [isEdit, setIsEdit] = React.useState(false);
  const [getOneTableData, setGetOneTableData] = React.useState([]);
  const [editId, setEditId] = React.useState('');
  const [editTableData, setEditTableData] = React.useState([]);
  const [qrModal, setQrModal] = React.useState(false);
  const [qrImage, setQrImage] = React.useState('');
  const [tableName, setTableName] = React.useState('');

  const dispatch = useDispatch();

  const handleModal = () => {
    setIsEdit(false);
    setEditId('');
    setShowModal(!showModal);
    {
      !isEdit && setEditTableData([]);
    }
  };
  const handleEdit = (data: any) => {
    setEditTableData(data);
    setIsEdit(true);
    setEditId(data.id);
    setShowModal(true);
  };

  const { tableData, loading } = useSelector(
    ({ tableData }: RootState) => tableData,
    shallowEqual
  );

  React.useEffect(() => {
    if (tableData.length > 0) return;
    dispatch(fetchTable() as any);
  }, [dispatch]);

  const searchTableFilterData = tableData?.filter((item) => {
    if (query === '') {
      return item;
    } else if (item) {
      return item?.name?.toLowerCase().includes(query.toLowerCase());
    }
  });

  const tableColumn = [
    { Header: 'Table Name', accessor: 'name' },
    { Header: 'Pax', accessor: 'occupancy' },

    {
      Header: 'Floor Name',
      Cell: (row: any) => (
        <div className="flex items-center space-x-3">
          <p className="text-text-black">
            {row?.cell?.row?.original?.floor?.name?.length > 10
              ? row?.cell?.row?.original?.floor?.name?.slice(0, 8) + '..'
              : row?.cell?.row?.original?.floor?.name}
          </p>
        </div>
      ),
    },
    {
      Header: 'Qr',
      Cell: (row: any) => (
        <>
          <button
            onClick={() => handleShowqr(row)}
            className="min-w-fit ring-1 ring-primary text-primary text-xs xl:text-base rounded px-2 xl:px-4 py-2 capitalize font-semibold disabled:text-opacity-70  disabled:bg-opacity-40  disabled:cursor-not-allowed"
          >
            View
          </button>
        </>
      ),
    },
    {
      Header: 'Action',

      Cell: (row: any) => (
        <CrudIcon
          data={row?.cell?.row?.original}
          url="/floors/tables/remove"
          fetchData={fetchTable() as any}
        >
          <div
            className="w-7 h-7 rounded-xl bg-light-grey bg-opacity-50 flex items-center justify-center"
            onClick={() => handleEdit(row?.cell?.row?.original)}
          >
            <MdEdit color="#4062FF" />
          </div>
        </CrudIcon>
      ),
    },
  ];

  const handleShowqr = (val: any) => {
    setQrModal(true);
    setQrImage(val?.cell?.row?.original?.qr);
    setTableName(val?.cell?.row?.original?.name ?? '');
  };
  const handleQrModal = () => {
    setQrModal(false);
  };

  // const [image, setImage] = useState<null | any>(null);

  // async function getBase64Image(imgUrl: any) {
  //   const response = await fetch(imgUrl);
  //   const blob = await response.blob();
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onloadend = () => resolve(reader.result);
  //     reader.onerror = reject;
  //     reader.readAsDataURL(blob);
  //   });
  // }

  // getBase64Image(
  //   'https://fantasticpos1.s3.ap-south-1.amazonaws.com/qrs/1699006852658-242efe37-a110-4523-97d1-f1667da9d72f.png'
  // )
  //   .then((data) => setImage(data))
  //   .catch((error) => );

  // const pdfRef = useRef<any>();
  // const [isImageLoaded, setIsImageLoaded] = useState(false);
  // const handleImageLoad = () => {
  //   setIsImageLoaded(true);
  // };

  // // const handleDownload = () => {
  // //   if (!isImageLoaded) {
  // //     alert('Please wait for the image to load.');
  // //     return;
  // //   }

  // //   const capture: any = document.querySelector('#pdf-doc');

  // //   html2canvas(capture).then((canvas) => {
  // //     const imgData = canvas.toDataURL('image/png');
  // //     const doc = new jsPDF('p', 'mm', 'a4');
  // //     doc.addImage(imgData, 'PNG', 30, 50, 200, 350);
  // //     doc.save('qr.pdf');
  // //   });

  // const handleDownload = async () => {
  //   if (!isImageLoaded) {
  //     alert('Please wait for the image to load.');
  //     return;
  //   }
  //   const input = pdfRef.current;
  //   html2canvas(input).then((canvas) => {
  //     const imgData = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF('p', 'mm', 'a4', true);
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = 200;
  //     const imgWidth = canvas.width;
  //     const imgHeight = canvas.height;
  //     const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
  //     const imgX = (pdfWidth - imgWidth * ratio) / 2;
  //     const imgY = 30;
  //     pdf.addImage(
  //       imgData,
  //       'PNG',
  //       imgX,
  //       imgY,
  //       imgWidth * ratio,
  //       imgHeight * ratio
  //     );
  //     pdf.save('qr.pdf');
  //   });
  // };
  return (
    <>
      {/* <div ref={pdfRef}>
        p<p className="text-[red]">Sumit</p>
        <img src={image} alt="" onLoad={handleImageLoad} />
      </div> */}
      {/* <p className="text-[black]" onClick={handleDownload}>
        Dwnload
      </p> */}
      <div className="grid-cols-12 gap-4 grid">
        <div className="col-span-12 md:col-span-12">
          {/* <HeadingWithCreateBtn
            icon={<AiOutlinePlus size={20} />}
            btnTxt="create table"
            title="Table"
            onClick={handleModal}
          />
          <Search
            placeholder="search floors ....."
            query={query}
            setQuery={setQuery}
          /> */}
          <div className="flex items-center justify-between ">
            <Search
              placeholder="search table"
              query={query}
              setQuery={setQuery}
            />
            <Button
              text={'Add Table'}
              variant="primary"
              onClick={handleModal}
              icon={<AiOutlinePlus size={20} />}
            />
          </div>
          <div className="pb-20">
            <Table
              loading={loading}
              tableColumn={tableColumn}
              tableData={searchTableFilterData}
              pagination={true}
            />
          </div>
        </div>
      </div>
      {qrModal && (
        <QrModal
          tableName={tableName}
          img={qrImage}
          qrModal={qrModal}
          setQrModal={setQrModal}
          onClick={handleQrModal}
        />
      )}

      <AddTables
        editTableData={editTableData}
        handleModal={handleModal}
        showModal={showModal}
        editId={editId}
        isEdit={isEdit}
        setEditId={setEditId}
        setIsEdit={setIsEdit}
      />
    </>
  );
};

export default React.memo(Tables);
